/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { core, toJSON, toJSONArray } from '@tock/coretypes';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

export interface State {
  bankAccount?: dashboard.BankAccount;
  businessPolicies?: core.BusinessPolicies;
  businessTaxes: core.BusinessTax[];
  communicationPolicy?: core.CommunicationPolicy;
  data?: core.Business;
  isBusinessPoliciesInitialized: boolean;
  isCommunicationPolicyInitialized: boolean;
  isInitialized: boolean;
  maxOccupancy?: number;
  paymentAccount?: dashboard.Subscription;
  policiesBeingSubmitted?: any;
  policyBeingSubmitted?: any;
  printChitWhenSeating: boolean;
  releases?: core.BookingRelease[];
  requestInProgress: boolean;
  rollingReleaseDays?: number;
  rollingReleaseTime?: string;
}

const initialState: State = {
  bankAccount: undefined,
  businessPolicies: undefined,
  businessTaxes: [],
  communicationPolicy: undefined,
  data: undefined,
  isBusinessPoliciesInitialized: false,
  isCommunicationPolicyInitialized: false,
  isInitialized: false,
  maxOccupancy: undefined,
  paymentAccount: undefined,
  policiesBeingSubmitted: undefined,
  policyBeingSubmitted: undefined,
  printChitWhenSeating: false,
  releases: undefined,
  requestInProgress: false,
  rollingReleaseDays: undefined,
  rollingReleaseTime: undefined,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.BUSINESS_TAX_FETCH_FAILED:
    case AppConstants.BUSINESS_TAX_FETCH_STARTING:
      return {
        ...state,
        businessTaxes: initialState.businessTaxes,
      };
    case AppConstants.BUSINESS_TAX_FETCH_DONE:
      return {
        ...state,
        businessTaxes: toJSONArray<core.BusinessTax>(payload),
      };

    case AppConstants.BUSINESS_FETCH_DONE:
    case AppConstants.BUSINESS_UPDATE_DONE:
      return {
        ...state,
        data: toJSON<core.Business>(payload),
        isInitialized: true,
      };
    case AppConstants.BUSINESS_POLICIES_FETCH_DONE:
    case AppConstants.BUSINESS_POLICIES_UPDATE_DONE:
      return {
        ...state,
        businessPolicies: payload,
        isBusinessPoliciesInitialized: true,
      };
    case AppConstants.BUSINESS_COMMUNICATION_POLICY_FETCH_DONE:
    case AppConstants.BUSINESS_COMMUNICATION_POLICY_UPDATE_DONE:
      return {
        ...state,
        communicationPolicy: payload,
        isCommunicationPolicyInitialized: true,
      };
    case AppConstants.BUSINESS_PAYMENT_FETCH_DONE:
      return {
        ...state,
        paymentAccount: toJSON<dashboard.Subscription>(payload),
      };
    case AppConstants.TOCK_BANK_ACCOUNT_VERIFY_STARTING:
    case AppConstants.TOCK_BANK_ACCOUNT_UPDATE_STARTING:
    case AppConstants.TOCK_BANK_ACCOUNT_FETCH_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case AppConstants.TOCK_BANK_ACCOUNT_VERIFY_FAILED:
    case AppConstants.TOCK_BANK_ACCOUNT_UPDATE_FAILED:
    case AppConstants.TOCK_BANK_ACCOUNT_FETCH_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case AppConstants.TOCK_BANK_ACCOUNT_VERIFY_DONE:
    case AppConstants.TOCK_BANK_ACCOUNT_UPDATE_DONE:
    case AppConstants.TOCK_BANK_ACCOUNT_FETCH_DONE: {
      return {
        ...state,
        bankAccount: toJSON<dashboard.BankAccount>(payload),
        requestInProgress: false,
      };
    }
    case AppConstants.BANK_ACCOUNT_CLEAR: {
      return {
        ...state,
        bankAccount: {} as any,
      };
    }
    case AppConstants.BUSINESS_FETCH_STARTING:
    case AppConstants.BUSINESS_UPDATE_STARTING:
      return {
        ...state,
        isInitialized: false,
      };
    case AppConstants.BUSINESS_POLICIES_FETCH_STARTING:
      return {
        ...state,
        isBusinessPoliciesInitialized: false,
      };
    case AppConstants.BUSINESS_COMMUNICATION_POLICY_FETCH_STARTING:
      return {
        ...state,
        isCommunicationPolicyInitialized: false,
      };
    case AppConstants.BUSINESS_POLICIES_UPDATE_STARTING:
      return {
        ...state,
        isBusinessPoliciesInitialized: false,
        policiesBeingSubmitted: payload,
      };
    case AppConstants.BUSINESS_COMMUNICATION_POLICY_UPDATE_STARTING:
      return {
        ...state,
        isCommunicationPolicyInitialized: false,
        policyBeingSubmitted: payload,
      };

    case AppConstants.BUSINESS_FETCH_FAILED:
    case AppConstants.BUSINESS_UPDATE_FAILED:
      return {
        ...state,
        isInitialized: true,
      };
    case AppConstants.BUSINESS_POLICIES_FETCH_FAILED:
    case AppConstants.BUSINESS_POLICIES_UPDATE_FAILED:
      return {
        ...state,
        isBusinessPoliciesInitialized: true,
      };
    case AppConstants.BUSINESS_COMMUNICATION_POLICY_FETCH_FAILED:
    case AppConstants.BUSINESS_COMMUNICATION_POLICY_UPDATE_FAILED:
      return {
        ...state,
        isCommunicationPolicyInitialized: true,
      };
    case AppConstants.BUSINESS_DETAILS_PRINT_CHIT_WHEN_SEATING_UPDATE_DONE:
      return {
        ...state,
        data: payload,
      };
    case AppConstants.BOOKING_RELEASE_FETCH_DONE:
      return {
        ...state,
        releases: payload,
      };
    case AppConstants.BOOKING_RELEASE_CREATE_DONE: {
      const data = state.data;
      if (data) {
        data.ticketsAvailableUntil = payload.openUntil;
      }
      return {
        ...state,
        rollingReleaseDays: payload.rollingReleaseDays,
        rollingReleaseTime: payload.rollingReleaseTime,
      };
    }
    case AppConstants.BUSINESS_ACCOLADE_REORDER: {
      const { reorderedAccolades } = payload;
      const data = state.data;
      if (data) {
        data.accolade = reorderedAccolades;
      }

      return {
        ...state,
        data,
      };
    }
    case AppConstants.PASSCODE_CONFIG_FETCH_DONE:
    case AppConstants.PASSCODE_CONFIG_UPDATE_DONE:
      return {
        ...state,
        data: state.data && {
          ...state.data,
          passcodeMode: toJSON<dashboard.PasscodeBusinessConfig>(payload).passcodeMode,
        },
      };
    default:
      return state;
  }
}
